import { PageTitle } from "components/core/typography/PageTitle";
import { ContentGridMixContentQuery } from "components/domain/contents/ContentGridMixContentQuery";
import {
    MixContentDocument,
    Mix_Content_Status_Enum,
    Order_By
} from "graphql/generated";
import { GetServerSideProps } from "next";
import { getClient } from "utils/client";

const LIMIT = 20;

const buildQueryVariables = (): MixContentQueryVariables => ({
    where: {
        status: {
            _eq: Mix_Content_Status_Enum.Published
        },
        isoriginal: {
            _eq: true
        },
        released: {
            _eq: true
        }
    },
    orderBy: [{ updatedate: Order_By.Desc }, { id: Order_By.Asc }],
    limit: LIMIT,
    offset: 0
});

const OriginalPage = () => {
    return (
        <div className="w-full">
            <PageTitle className="text-text-primary dark:text-common-white-main">
                오리지널 콘텐츠
            </PageTitle>
            <ContentGridMixContentQuery
                disablePauseAt32={true}
                contentSection="original-page"
                variables={buildQueryVariables()}
                limit={LIMIT}
            />
        </div>
    );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
    const client = getClient({
        headers: {
            cookie: ctx.req.headers.cookie
        },
        ctx
    });

    try {
        await client.query<MixContentQuery, MixContentQueryVariables>({
            query: MixContentDocument,
            variables: buildQueryVariables()
        });
    } catch (error) {
        // SSR 쿼리 실패 시 빈 캐시로 페이지를 렌더링하고 클라이언트에서 재시도
    }

    return {
        props: {
            __APOLLO_CACHE_DATA__: client.extract()
        }
    };
};

export default OriginalPage;
